/**
 * Toggles readerTranslations between 'on' and 'off'.
 *
 *  on:  shows a small right-pointing arrow
 *  off: shows a cross
 */
import * as preact from "preact";

import stores from "stores/stores";

class TranslationDirectionArrowView extends preact.Component {
  handleClick = () => {
    stores.user.save({
      readerTranslations:
        stores.user.readerTranslations.value === "off" ? "on" : "off",
    });
  };

  render() {
    const on = stores.user.readerTranslations.value !== "off";
    const icon = on ? (
      <i class="icon-arrow-right" />
    ) : (
      <i class="icon-remove" />
    );
    return (
      <span
        class="translationDirectionArrowView fadedHoverButton"
        onClick={this.handleClick}
      >
        {icon}
      </span>
    );
  }
}

export default TranslationDirectionArrowView;
